import { application } from "./application"

import IntegraStatusController from "./integra_status_controller"
import IntegraTestController from "./integra_test_controller"
import SyncStatusController from "./sync_status_controller"
import SyncTriggerController from "./sync_trigger_controller"
import PushToggleController from "./push_toggle_controller"
import PrazosStripController from "./prazos_strip_controller"
import PasswordVisibilityController from "./password_visibility_controller"

application.register("integra-status", IntegraStatusController)
application.register("integra-test", IntegraTestController)
application.register("sync-status", SyncStatusController)
application.register("sync-trigger", SyncTriggerController)
application.register("push-toggle", PushToggleController)
application.register("prazos-strip", PrazosStripController)
application.register("password-visibility", PasswordVisibilityController)
